import { GET, POST } from './api'

const buildLocaleQuery = locale => (
  locale ? `?locale=${encodeURIComponent(locale)}` : ''
)

export const ReadCourseSurvey = async (courseId, locale) => (
  GET(`/courses/${courseId}/survey${buildLocaleQuery(locale)}`, true)
)

export const ReadCourseSurveyStatus = async (courseId, locale) => (
  GET(`/courses/${courseId}/survey/status${buildLocaleQuery(locale)}`, true)
)

export const SubmitCourseSurvey = async (courseId, answers, locale, productArea) => (
  POST(
    `/courses/${courseId}/survey/submit${buildLocaleQuery(locale)}`,
    { answers, productArea },
    true
  )
)
